import {AbstractControl, ValidationErrors} from "@angular/forms";


export const MinDateValidator = (minDate: Date) => (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }
  return new Date(control.value) < minDate ? {minDate: true} : null;
}

export const MaxDateValidator = (maxDate: Date) => (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }
  return new Date(control.value) > maxDate ? {maxDate: true} : null;
}

export const MinLengthValidator = (minLength: number) => (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }
  return control.value.length < minLength ? {minLength: true} : null;
}

export const MaxLengthValidator = (maxLength: number) => (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }
  return control.value.length > maxLength ? {maxLength: true} : null;
}

export const MinNumberValidator = (min: number) => (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }
  return control.value < min ? {min: true} : null;
}

export const MaxNumberValidator = (max: number) => (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }
  return control.value > max ? {max: true} : null;
}

export const PatternValidator = (pattern: RegExp) => (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }
  return !pattern.test(control.value) ? {pattern: true} : null;
}

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const phoneRegex = /^\+?[0-9]{1,3}(\s|-)?\(?[0-9]{3}\)?(\s|-)?[0-9]{3}(\s|-)?[0-9]{4}$/;
export const PhoneValidator = PatternValidator(phoneRegex);
export const EmailValidator = PatternValidator(emailRegex);
